import { RowData, ToastInfo } from "../../../types";
import {
  BULK_IMPORT_FIELD_KEYS,
  DEFAULT_TOAST,
  TOAST_MESSAGES,
} from "../constants";

type ImportStatusCounts = {
  success: number;
  failure: number;
  aborted: number;
};

export const getImportStatusCounts = (rows: RowData[]): ImportStatusCounts => {
  const counts: ImportStatusCounts = { success: 0, failure: 0, aborted: 0 };
  for (const row of rows) {
    const status = (
      row[BULK_IMPORT_FIELD_KEYS.RECORD_IMPORT_STATUS] as string
    )?.toLowerCase();
    if (status === "success" || status === "failure" || status === "aborted") {
      counts[status] += 1;
    }
  }
  return counts;
};

export const getImportToastMessage = (
  counts: ImportStatusCounts,
): ToastInfo => {
  if (counts.failure > 0) {
    return TOAST_MESSAGES.FILE_IMPORT_STATUS(
      counts.success,
      counts.failure,
      counts.aborted,
    );
  }
  if (counts.success > 0) {
    return TOAST_MESSAGES.FILE_IMPORT_SUCCESS_STATUS(counts.success);
  }
  return DEFAULT_TOAST;
};
